import { render, staticRenderFns } from "./SignerRoleList.vue?vue&type=template&id=3a38b951"
import script from "./SignerRoleList.vue?vue&type=script&lang=js"
export * from "./SignerRoleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports